module.exports = __webpack_public_path__ + "static/og_climate-33a5ef47ca23ac1041d86d87737f91f9.jpg";